'use client';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@practium/features/auth';
import { ShieldX } from 'lucide-react';
import { Logo } from '../../components/Logo/Logo';
import { BasePrimaryButton } from '../../components/Buttons/BasePrimaryButton/BasePrimaryButton';
import styles from './Unauthorized.module.css';
import { Button } from '../../components';

export const Unauthorized = () => {
	const navigate = useNavigate();
	const { logout } = useAuth();

	const handleLogout = async () => {
		await logout();
		navigate('/login', { replace: true });
	};

	const handleGoBack = () => {
		navigate(-1);
	};

	return (
		<div className={styles.container}>
			<div className={styles.logoContainer}>
				<Logo />
			</div>

			<div className={styles.content}>
				<div className={styles.iconWrapper}>
					<ShieldX size={64} className={styles.icon} />
				</div>

				<h1 className={styles.errorCode}>403</h1>
				<h2 className={styles.title}>Acesso Negado</h2>
				<p className={styles.message}>Você não tem permissão para acessar esta área.</p>

				<div className={styles.actions}>
					<Button variant='secondary' onClick={handleGoBack} className={styles.buttonSecondary}>
						Voltar
					</Button>
					<BasePrimaryButton onClick={handleLogout} className={styles.buttonPrimary}>
						Fazer Logout
					</BasePrimaryButton>
				</div>
			</div>
		</div>
	);
};
